import React from 'react';
import {
  WavesContainerStyled,
  FirstSceneLayerStyled,
  SecondSceneLayerStyled,
  ThridSceneLayerStyled,
} from './styles/HeaderSceneStyled';

import { ReactComponent as MainWave } from '../../../images/layouts/detalle-otras-lineas/header-layer-1.svg';
import { ReactComponent as SecondWave } from '../../../images/layouts/detalle-otras-lineas/header-layer-2.svg';
import { ReactComponent as ThrirdWave } from '../../../images/layouts/detalle-otras-lineas/header-layer-3.svg';

const HeaderScene = () => (
  <WavesContainerStyled>
    <FirstSceneLayerStyled>
      <MainWave />
    </FirstSceneLayerStyled>
    <SecondSceneLayerStyled>
      <SecondWave />
    </SecondSceneLayerStyled>
    <ThridSceneLayerStyled>
      <ThrirdWave />
    </ThridSceneLayerStyled>
  </WavesContainerStyled>
);
export default HeaderScene;
